export default __webpack_public_path__ + "static/media/gallery_01.480d4ab4.jpg";